import * as React from "react";
import { Outlet } from "react-router";
import { Toaster } from "@/components/ui/toaster";
import { useLocalStorage } from "react-use";
import { ToastProvider } from "@/components/ui/toasts/toastProvider";
import { motion } from "framer-motion";
import { SidebarNav } from "@/components/sidebar/Sidebar";
import { PromptLibraryContextProvider } from "@/modules/promptLibrary/promptLibrary.context";

export const RootLayout: React.FC = () => {
  const [sidebarPinned, setSidebarPinned] = useLocalStorage("sidebarPinned", true);

  const handleSidebarPinChange = React.useCallback(
    (isPinned: boolean) => {
      setSidebarPinned(isPinned);
    },
    [setSidebarPinned],
  );

  const sidebarWidth = React.useMemo(() => (sidebarPinned === true ? "18rem" : "4rem"), [sidebarPinned]);

  return (
    <PromptLibraryContextProvider>
      <div className="flex h-screen bg-ui-app-background">
        <ToastProvider>
          <div className="relative flex flex-grow flex-col">
            <SidebarNav isPinned={sidebarPinned === true} onPinChange={handleSidebarPinChange} />
            <motion.div
              className="relative flex flex-grow flex-col"
              initial={false}
              animate={{
                marginLeft: sidebarWidth,
              }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
            >
              <main className="flex-grow overflow-auto">
                <div className="px-4 py-8 sm:px-6 lg:px-8">
                  <Outlet />
                </div>
              </main>
            </motion.div>
          </div>
          <Toaster />
        </ToastProvider>
      </div>
    </PromptLibraryContextProvider>
  );
};
